import api from './base-api';
import { CreateFeaturedImageDto, UpdateFeaturedImageDto } from '@sportspredict/shared';

const featuredImagesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getFeaturedImages: builder.query<any[], void>({
			query: () => ({
				url: 'featured-images',
				params: { sort: 'order' },
			}),
			providesTags: [{ type: 'FeaturedImage', id: 'LIST' }],
		}),
		createFeaturedImage: builder.mutation<any, CreateFeaturedImageDto>({
			query: (data) => ({
				url: 'featured-images',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: [{ type: 'FeaturedImage', id: 'LIST' }],
		}),
		updateFeaturedImage: builder.mutation<void, UpdateFeaturedImageDto>({
			query: ({ id, ...rest }) => ({
				url: 'featured-images',
				method: 'PUT',
				body: { id, ...rest },
			}),
			invalidatesTags: [{ type: 'FeaturedImage', id: 'LIST' }],
		}),
		deleteFeaturedImage: builder.mutation<void, string>({
			query: (id) => ({
				url: `featured-images/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: [{ type: 'FeaturedImage', id: 'LIST' }],
		}),
	}),
});

export const {
	useGetFeaturedImagesQuery,
	useLazyGetFeaturedImagesQuery,
	useCreateFeaturedImageMutation,
	useUpdateFeaturedImageMutation,
	useDeleteFeaturedImageMutation,
} = featuredImagesApi;
